import React from 'react';
export const TabAction = ({ children }) => {
    return React.createElement("div", { className: "TabGroup__action" }, children);
};
//# sourceMappingURL=components.js.map